export const ERROR_MESSAGE_TITLE = 'Sorry, we had an issue fetching the details of your order.';
